import React, { useMemo, useState } from "react";
import { TeamMember } from "../../../../../types";
import { ProgramForm, ProgramFormsFilters, SectionFormRelation } from "../../types";
import { getFullNameOrEmail } from "../../../../../redux/user";
import { Collapse, Table, TableBody, TableCell, TableRow } from "@mui/material";
import TrainingProgramFormRow from "./TrainingProgramFormRow";
import { getFilterTrainingProgramForms, getSearchTrainingProgramForms, getSectionFormRelationMatchesFilter } from '../../../../../helpers/osha-hipaa-forms/helpers'

const ProgramFormRow = (props: {
  setFileUploadModalIsOpen: (open: boolean) => void;
  setSelectedForm: (id: number) => void;
  setSelectedTrainingForm: (id: number) => void;
  teamMembersById: Map<number, TeamMember>;
  handleDeleteClick: (id: number) => void;
  handleAddForm: (id: number) => void;
  handleEditTeamMember: (form: ProgramForm, formTeamMembers: TeamMember[]) => void;
  colWidths: number[];
  filters: ProgramFormsFilters | null;
  searchValue: string;
  sectionFormRelation: SectionFormRelation;
  filterValuesSet: boolean;
  programId?: number;
  sectionId: number;
}) => { 
  const {
    teamMembersById,
    filters,
    searchValue,
    sectionFormRelation,
    filterValuesSet,
    programId,
    sectionId
  } = props

  const [open, setOpen] = useState(true);

  const filterTrainingProgramForms = getFilterTrainingProgramForms(filters, filterValuesSet)
  const searchTrainingProgramForms = getSearchTrainingProgramForms(searchValue)
  const sectionFormRelationMatchesFilters = getSectionFormRelationMatchesFilter(searchValue, filters)

  const form = sectionFormRelation.form
  const trainingProgramForms = sectionFormRelation.training_program_forms?.filter(f => f.section_id === sectionId) ?? []
  const formTeamMembers: TeamMember[] = []

  const uploaded = { count: 0 }
  
  trainingProgramForms.forEach(programForm => {
    const userId = Number(programForm.user_id)
    const user = teamMembersById.get(userId)
    const isSectionMatch = programForm.section_id === sectionId

    if (user && isSectionMatch) formTeamMembers.push(user)
    if (programForm.file_id && isSectionMatch) uploaded.count++
  })

  const showParentRow = useMemo(() => {
    if ((filters && filterValuesSet) || searchValue !== '') {
      if (trainingProgramForms.length > 0 && form.is_practice_only) {
        const ids = {
          uploadedBy: trainingProgramForms[0].uploaded_by,
          teamMember: Number(trainingProgramForms[0].user_id),
        }

        const users = {
          uploadedBy: teamMembersById.get(ids.uploadedBy),
          teamMember: teamMembersById.get(ids.teamMember),
        }

        const uploadedBy = ids.uploadedBy ? getFullNameOrEmail(users.uploadedBy) : ''
        const teamMember = ids.teamMember ? getFullNameOrEmail(users.teamMember) : ''

        const filtersMatched = filterTrainingProgramForms(sectionFormRelation, uploadedBy, teamMember, trainingProgramForms[0])
        const searchMatched = searchTrainingProgramForms(sectionFormRelation, uploadedBy, teamMember, trainingProgramForms[0])

        return filtersMatched && searchMatched
      } else {
        return sectionFormRelationMatchesFilters(sectionFormRelation)
      }
    }
    return true;
  }, [filters, searchValue, trainingProgramForms])

  
  const trainingProgramForm = trainingProgramForms.length ? trainingProgramForms[0] : null

  return (
    <React.Fragment>
      {showParentRow ? <TrainingProgramFormRow
        {...props}
        form={form}
        trainingProgramForm={trainingProgramForm}
        isCollapsedRow={false}
        formTeamMembers={formTeamMembers}
        uploadedCount={uploaded.count}
        setOpen={setOpen}
        open={open}
        filters={filters}
        searchValue={searchValue}
        isMultipleUploads={form.is_multiple_uploads}
        filterValuesSet={filterValuesSet}
        programId={programId}
        sectionId={sectionId}
      /> : null}
      {(!form.is_practice_only || form.is_multiple_uploads) && open && trainingProgramForms.length > 0 ?
        <TableRow style={{ padding: 0, margin: 0 }}>
          <TableCell style={{ padding: 0 }} colSpan={8}>
            <Collapse style={{ padding: 0 }} in={open} timeout="auto" unmountOnExit>
              <Table size="small">
                <TableBody>
                  {trainingProgramForms.map((trainingProgramForm, index) => (
                    <TrainingProgramFormRow
                      {...props}
                      form={form}
                      key={trainingProgramForm.id}
                      trainingProgramForm={trainingProgramForm}
                      isCollapsedRow={true}
                      formTeamMembers={formTeamMembers}
                      uploadedCount={uploaded.count}
                      setOpen={setOpen}
                      open={open}
                      filters={filters}
                      searchValue={searchValue}
                      isMultipleUploads={form.is_multiple_uploads}
                      filterValuesSet={filterValuesSet}
                      programId={programId}
                      sectionId={sectionId}
                    />
                  ))}
                </TableBody>
              </Table>
            </Collapse>
          </TableCell>
        </TableRow>
      : null}
    </React.Fragment>
  );
}

export default ProgramFormRow